var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"df-empty-wrapper"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"empty-content"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }